// Builds a Set of string IDs from selectedRows.
// For multi-select: if select-all was never toggled and `value` has IDs not yet loaded in `data`, those IDs are preserved — they were implicitly selected but never rendered. Single-select is a straight replacement — the user's new selection is the whole answer, so we never carry the previous value forward.
export const buildSelectedIdSet = (
  selectedRows: Record<string, unknown>[],
  idItem: string,
  value: string,
  data: Record<string, unknown>[] | null | undefined,
  selectAllToggled: boolean,
  delimiter: string = ',',
  multiSelect: boolean = true,
  deselectedRowIds: Set<string> = new Set<string>()
): Set<string> => {
  const idSet = new Set<string>(
    selectedRows.map((row) => row[idItem]?.toString() ?? '')
  );

  if (multiSelect && !selectAllToggled && value !== '') {
    // Avoid re-including IDs that are already in the loaded page
    const loadedIdSet = new Set(
      (data ?? []).map((row) => row[idItem]?.toString())
    );
    value
      .split(delimiter)
      .filter(Boolean)
      .forEach((id) => {
        // An off-window ID the user explicitly unchecked must not come back.
        if (!loadedIdSet.has(id) && !deselectedRowIds.has(id)) {
          idSet.add(id);
        }
      });
  }

  return idSet;
};
